export enum SocketEvent {
  ONLINE_STAFFS = 'online_staffs',
  ONLINE_USERS = 'online_users',

  // consultation
  CONSULTATION_CREATED = 'consultation_created',
  CONSULTATION_UPDATED = 'consultation_updated',
  LIVE_TRANSCRIPTION_SEGMENT = 'live_transcription_segment',

  // consultation order
  CONSULTATION_ORDER_CREATED = 'consultation_order_created',

  // join action
  ENTER_CONSULTATION = 'connectConsultation', // TODO: rename event name
  ENTER_EMERGENCY_ROOM = 'enter_emergency_room',
  ENTER_EXPERTISE_MEETING = 'enter_expertise_meeting',
  ENTER_MEETING_LINK = 'enter_meeting_link',
  ENTER_WAITING_ROOM = 'enter_waiting_room',

  // leave action
  LEAVE_CONSULTATION = 'disconnectConsultation', // TODO: rename event name
  LEAVE_EMERGENCY_ROOM = 'leave_emergency_room',
  LEAVE_EXPERTISE_MEETING = 'leave_expertise_meeting',
  LEAVE_MEETING_LINK = 'leave_waiting_room',
  LEAVE_WAITING_ROOM = 'leave_waiting_room',

  // expertise
  EXPERTISE_MEETING_UPDATED = 'expertise_meeting_updated',
  EXPERTISE_MEETING_REQUEST_ACCESS_ACCEPTED = 'expertise_meeting_request_access_accepted',
  EXPERTISE_MEETING_REQUEST_ACCESS_SENT = 'expertise_meeting_request_access_sent',
  EXPERTISE_MEETING_REQUEST_ACCESS_DECLINED = 'expertise_meeting_request_access_declined',
  EXPERTISE_ORDER_CREATED = 'expertise_order_created',
  EXPERTISE_ORDER_UPDATED = 'expertise_order_updated',

  // network
  NETWORK_UPDATED = 'network_updated',
  NETWORK_DELETED = 'network_deleted',
  NETWORK_INVITATION_SENT = 'network_invitation_sent',
  NETWORK_INVITATION_DELETED = 'network_invitation_deleted',
  NETWORK_MEMBER_CREATED = 'network_member_created',
  NETWORK_MEMBER_UPDATED = 'network_member_updated',
  NETWORK_MEMBERS_DELETED = 'network_members_deleted',
  SUBSCRIBE_NETWORKS = 'subscribe_networks',
  UNSUBSCRIBE_NETWORKS = 'unsubscribe_networks',

  // order
  PENDING_ORDER = 'pending_order',

  // waiting room
  WAITING_ROOM_UPDATED = 'waiting_room_updated',
  // doctor status
  DOCTOR_STATUS_UPDATED = 'doctor_status_updated',
  DOCTOR_HEARTBEAT = 'doctor_heartbeat',
  WAITING_ROOM_DOCTORS_STATUS = 'waiting_room_doctors_status',
  // fair-turn ("offer"/Uber-style) distribution
  FAIR_TURN_OFFER_UPDATED = 'fair_turn_offer_updated',

  SEND_MESURES = 'send_mesures',

  // recording consent 
  RECORDING_CONSENT_REQUESTED = 'recording_consent_requested',
  RECORDING_CONSENT_RESPONSED = 'recording_consent_responsed',
  RECORDING_STARTED = 'recording_started',
  RECORDING_STOPPED = 'recording_stopped',

  // time tracking
  TIME_TRACKING_SESSION_UPDATED = 'time_tracking_session_updated',
}
